import React, { Suspense } from 'react'
import { Navigate, Outlet, type RouteObject } from 'react-router-dom'
import { LayoutMain } from '../../../layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '../../../routes/routes.components'
import { EnPIProvider } from '../../iso-suite/enpi/EnPIContext'

import { MESSSTELLEN_BASE_ROUTE, TABS } from '@/src/utils/constants'
const MeterViewScreenLazy = React.lazy(() => import('../../meter-view/components/meter-view.screen'))
const MesstellenDetailsLazy = React.lazy(() => import('../MessstellenDetails.page'))
const NewMesstellenScreenLazy = React.lazy(() => import('../Messstellen.screen'))
const MeterOverviewLazy = React.lazy(() => import('../MeterOverview'))
const EnergyEvaluationLazy = React.lazy(() => import('../EnergyEvaluation/EnergyEvaluation.screen'))
// EC-5827: EnPI as the last Messstellen tab, behind the easy-offer-enpi feature flag
const ENPILazy = React.lazy(() => import('../../iso-suite/enpi/ENPI'))
const EnPIDetailsPageLazy = React.lazy(() => import('../../iso-suite/enpi/EnPIDetails.page'))
const CreateEditEnPIPageLazy = React.lazy(() => import('../../iso-suite/enpi/CreateEditEnPI.page'))

const NewMesstellenScreen = (
  <Suspense fallback={<div></div>}>
    <NewMesstellenScreenLazy />
  </Suspense>
)

const MeterViewScreen = (
  <Suspense fallback={<div></div>}>
    <MeterViewScreenLazy />
  </Suspense>
)

const MeterOverviewScreen = (
  <Suspense fallback={<div></div>}>
    <MeterOverviewLazy />
  </Suspense>
)

const EnergyEvaluationScreen = (
  <Suspense fallback={<div></div>}>
    <EnergyEvaluationLazy />
  </Suspense>
)

const EnpiOverviewScreen = (
  <Suspense fallback={<div></div>}>
    <ENPILazy />
  </Suspense>
)

const EnpiDetailsPage = (
  <Suspense fallback={<div></div>}>
    <EnPIDetailsPageLazy />
  </Suspense>
)

const CreateEditEnpiPage = (
  <Suspense fallback={<div></div>}>
    <CreateEditEnPIPageLazy />
  </Suspense>
)

export const getMesstellenRoutes = (isEasyOfferEnpiEnabled: boolean): RouteObject[] => [
  {
    path: `${MESSSTELLEN_BASE_ROUTE}`,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      { path: '', element: <Navigate replace to={TABS.messstellen.overview} /> },
      {
        path: TABS.messstellen.overview,
        element: NewMesstellenScreen,
        children: [{ path: '', element: MeterOverviewScreen }],
      },
      {
        path: TABS.messstellen.customViews,
        element: NewMesstellenScreen,
        children: [{ path: '', element: MeterViewScreen }],
      },
      {
        path: TABS.messstellen.energyEvaluation,
        element: NewMesstellenScreen,
        children: [{ path: '', element: EnergyEvaluationScreen }],
      },
      // EC-5827: EnPI as the last Messstellen tab. New/edit/detail are siblings of the enpi overview entry
      // (not its children) so the tab bar hides on them, following the same convention as the `:deviceId`
      // route below. All four still share a single EnPIProvider via this pathless wrapper route, so status
      // set by CreateEditEnPI.page.tsx after navigating away mid-mutation still reaches ENPITable's toast.
      ...(isEasyOfferEnpiEnabled
        ? [
            {
              element: (
                <EnPIProvider>
                  <Outlet />
                </EnPIProvider>
              ),
              children: [
                {
                  path: TABS.messstellen.enpi,
                  element: NewMesstellenScreen,
                  children: [{ path: '', element: EnpiOverviewScreen }],
                },
                { path: `${TABS.messstellen.enpi}/new`, element: CreateEditEnpiPage },
                { path: `${TABS.messstellen.enpi}/:enpiId/edit`, element: CreateEditEnpiPage },
                { path: `${TABS.messstellen.enpi}/:enpiId`, element: EnpiDetailsPage },
              ],
            },
          ]
        : []),
      {
        path: ':deviceId',
        element: (
          <Suspense fallback={<div />}>
            <MesstellenDetailsLazy />
          </Suspense>
        ),
      },
    ],
  },
]
